import constants from '@/helpers/constants';

const state = {
    event: {
        type: constants.EVENT_INFO,
        message: '',
        display: false,
    },

    apiEvent: {
        message: '',
    },
};

const mutations = {
    setApiEvent(state, message) {
        state.apiEvent.message = message;
    },
    setEvent(state, { type, message }) {
        state.event.type = type;
        state.event.message = message;
        state.event.display = true;
    },
    hideEvent(state) {
        state.event.display = false;
    },
};

const actions = {
    setApiEvent({ commit }, message) {
        commit('setApiEvent', message);
    },
    showInfo({ commit }, message) {
        const info = {
            type: constants.EVENT_INFO,
            message,
        };

        commit('setEvent', info);
    },
    showSuccess({ commit }, message) {
        const info = {
            type: constants.EVENT_SUCCESS,
            message,
        };

        commit('setEvent', info);
    },
    showWarning({ commit }, message) {
        const info = {
            type: constants.EVENT_WARNING,
            message,
        };

        commit('setEvent', info);
    },
    showError({ commit }, message) {
        const info = {
            type: constants.EVENT_ERROR,
            message,
        };

        commit('setEvent', info);
    },
    hideEvent({ commit }) {
        commit('hideEvent');
    },
};

const getters = {
    apiEvent(state) {
        return state.apiEvent;
    },
    event(state) {
        return state.event;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/events.js